export const categories = {
  informatique: {
    name: "Informatique et Électronique",
    subcategories: [
      { id: "reseaux", name: "Équipements Réseaux" },
      { id: "telephonie", name: "Téléphonie" },
      { id: "informatique", name: "Informatique" },
      { id: "accessoires", name: "Accessoires" },
      { id: "video_surveillance", name: "Vidéo Surveillance" },
      { id: "materiel_bureau", name: "Matériel de Bureau" },
      { id: "impression", name: "Imprimantes" },
      { id: "tablettes", name: "Tablettes" },
      { id: "impression_3d", name: "Imprimantes 3D" },
      { id: "drones", name: "Drones Professionnels" },
      { id: "audiovisuel", name: "Équipements Audiovisuels" },
      { id: "retroprojecteurs", name: "Rétroprojecteurs" },
    ],
  },

  Mobilier_accessoirs_workspace: {
    name: "Mobilier des Espaces de Travail et Accessoires",
    subcategories: [
      { id: "chaises_bureau", name: "Chaises de Bureau" },
      { id: "bureaux", name: "Bureaux et Tables de Travail" },
      { id: "coworking_spaces", name: "Mobilier pour Coworking" },
      { id: "rangements_bureau", name: "Rangements et Classements" },
      { id: "accueil_reception", name: "Mobilier d’Accueil et Réception" },
      { id: "salles_reunion", name: "Mobilier pour Salles de Réunion" },
      { id: "eclairage_bureau", name: "Éclairage de Bureau" },
      { id: "accessoires_ergonomiques", name: "Accessoires Ergonomiques" },
      { id: "espaces_detente", name: "Mobilier pour Espaces de Détente" },
      { id: "mobilier_open_space", name: "Mobilier pour Open Space" },
      { id: "panneaux_phonique", name: "Panneaux Acoustiques et Phoniques" },
      { id: "mobilier_direction", name: "Mobilier de Direction" },
      { id: "baches_projection", name: "Bâches de Projection" }, // Nouvelle sous-catégorie
      { id: "ecrans_formation", name: "Écrans pour Salles de Formation" }, // Nouvelle sous-catégorie
      { id: "whiteboards", name: "Tableaux Blancs" }, // Nouvelle sous-catégorie
    ],
  },
  vehicules: {
    name: "Transport et Logistique",
    subcategories: [
      { id: "vehicules_utilitaires", name: "Véhicules Utilitaires" },
      { id: "motos", name: "Motos" },
      { id: "engins_chantier", name: "Engins de Chantier" },
      { id: "transport_en_commun", name: "Transport en Commun" },
      { id: "vehicules_speciaux", name: "Véhicules Spéciaux" },
      { id: "bateaux", name: "Bateaux" },
    ],
  },
  machines_industrielles: {
    name: "Machines Industrielles",
    subcategories: [
      { id: "machines_outils", name: "Machines Outils" },
      { id: "equipement_chantier", name: "Équipement de Chantier" },
      { id: "machines_production", name: "Machines de Production" },
      { id: "machines_textile", name: "Machines Textiles" },
      { id: "machines_metallurgie", name: "Machines de Métallurgie" },
      { id: "machines_agroalimentaires", name: "Machines Agroalimentaires" },
    ],
  },
  equipements_professionnels: {
    name: "Équipements Professionnels",
    subcategories: [
      { id: "pour_electricite_industrielle", name: "Pour Électricité Industrielle" },
      { id: "pour_mecanique_automobile", name: "Pour Mécanique Automobile" },
      { id: "pour_plomberie", name: "Pour Plomberie" },
      { id: "pour_coiffure_professionnelle", name: "Pour Coiffure Professionnelle" },
      { id: "pour_couture_professionnelle", name: "Pour Couture Professionnelle" },
      { id: "pour_dentisterie", name: "Pour Dentisterie" },
      { id: "pour_entretien_surface", name: "Pour Entretien de Surface" },
      { id: "pour_cordonnerie", name: "Pour Cordonnerie" },
      { id: "pour_laboratoire_microbiologie", name: "Pour Laboratoire de Microbiologie" },
      { id: "pour_cuisine_professionnelle", name: "Pour Cuisine Professionnelle" },
    ],
  },
  agriculture: {
    name: "Agriculture et Élevage",
    subcategories: [
      { id: "machines_agricoles", name: "Machines Agricoles" },
      { id: "equipements_elevage", name: "Équipements d'Élevage" },
      { id: "stockage_agricole", name: "Stockage Agricole" },
    ],
  },
  energie_eau: {
    name: "Énergie et Eau",
    subcategories: [
      { id: "groupes_electrogenes", name: "Groupes Électrogènes" },
      { id: "pompage", name: "Pompage" }, // Updated to match mock data
      { id: "solaire", name: "Énergie Solaire" },
      { id: "forage", name: "Forage" },
      { id: "irrigation_solaire", name: "Irrigation Solaire" },
      { id: "pompage_solaire", name: "Pompage Solaire" },
    ],
  },
  evenementiel: {
    name: "Événementiel",
    subcategories: [
      { id: "tentes", name: "Tentes et Structures" },
      { id: "sonorisation", name: "Sonorisation" },
      { id: "materiel_livraison", name: "Matériel de Livraison" },
    ],
  },
};
